export const environment = {
  production: true,
  functionBaseUrl: 'https://us-central1-objex-website.cloudfunctions.net',
};
